import React from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../util/translationUtility';

const MoreButton = ({onClick}) => 
<Button
    className="btn btn-cc-gray"
    onClick={onClick}
>
    {translateResourceString("/SearchApp/LoadMore")}
</Button>;

MoreButton.propType = {
    onClick: PropTypes.func.isRequired
};

export default MoreButton;